import { type AxiosInstance, HttpStatusCode, isAxiosError } from "axios";
import { SendToTrackingService } from "@/api/handlers/errors";

export interface IAddressTree {
  id: number;
  prefectureId: number;
  refId: number;
  parentRefId: number;
  name: string;
  level: number;
  prefectureCityId: number;
  createdAt: Date;
  updatedAt: Date;
}

interface IAddressTreeResponse {
  count: number;
  list: IAddressTree[];
}

export const getSelectNextLocation = async (
  apiClient: AxiosInstance,
  prefectureId: number,
  refId?: number
): Promise<IAddressTreeResponse> => {
  const url = refId
    ? `/option/address-tree/${prefectureId}/${refId}`
    : `/option/address-tree/${prefectureId}`;
  const response = await apiClient
    .get<IAddressTreeResponse>(url)
    .catch((error): void => {
      if (
        isAxiosError(error) &&
        (error.response?.status ?? HttpStatusCode.InternalServerError) >=
          HttpStatusCode.InternalServerError
      ) {
        SendToTrackingService(error);
      }
      return undefined;
    });
  if (response) {
    return response.status === HttpStatusCode.Ok
      ? response.data
      : { count: 0, list: [] };
  }
  return { count: 0, list: [] };
};
